import settingsFields from '@/components/services/settings/fields'

export default function(h, options) {
  return h(
    settingsFields(options),
    {
      props: {
        value: this.proxy,
        items: [ { props: { mask: /^[0-9]$/ } } ],
        dialog: true
      },
      on: {
        input: event => {
          this.proxy = event
        }
      }
    }
  )
}
